
const data = [
  {
    src: "/img/AnimalNutrition&Feed.webp",
    name: "Animal Nutrition & Feed",
  },
  {
    src: "/img/Cosmetics&PersonalCare.webp",
    name: "Cosmetics & Personal Care",
  },
  {
    src: "/img/DietarySupplements.webp",
    name: "Dietary Supplements",
  },
  {
    src: "/img/FunctionalFoods&Beverages.webp",
    name: "Functional Foods & Beverages",
  },
];
export default {
  data() {
    return {
      title: "APPLICATION AREA",
      subTitle:
        "Widely applied in pharmaceutical, nutraceutical, functional food and health industries worldwide.",
      data,
      swiperOption: {
        slidesPerView: 4,
        breakpoints: {
          320: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 4,
          },
        },
        scrollbar: {
          el: ".swiper-app-scrollbar",
        },
      },
    };
  },
};
